module.exports = __webpack_public_path__ + "img/icn_landing_completed.82163208.svg";